import { render, staticRenderFns } from "./MNoticeFrame.vue?vue&type=template&id=77c7cdc3&"
import script from "./MNoticeFrame.vue?vue&type=script&lang=ts&"
export * from "./MNoticeFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports